import React,{useEffect} from "react";
import {buyFromIg} from "../../../../../api";
import Loading from "../../../../components/loading/op-loading";
import classes from './style.module.scss'
import useStyles from "isomorphic-style-loader/useStyles";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import {action_cart_checkout} from "../../../../../store/actions/pages/cart";
import {useDispatch} from "react-redux";

const parseSearch = search => {
    const parsed = queryString.parse(search)
    return parsed
}
const FbCheckoutUrl = props => {
    useStyles(classes)
    const dispatch = useDispatch()
    const location = useLocation()
    const search = parseSearch(location.search)
    useEffect(async () => {
        if (window.GeekoSensors) {
            window.GeekoSensors.Track("INTER_IG_CART", {

            })
        }
        search["utm_source"]='ig_g_order';
        search["utm_campaign"]='ig_g_order';
        search["utm_medium"]='ig_g_order';
        search["utm_term"]='ig_g_order';
        search["utm_content"]='ig_g_order';
        search["utm_sku"]='ig_g_order';
        // console.log(search);
        const a=await buyFromIg(search);
        // console.log("@",a);
        // window.location.href = '/cart?utm_source=ig_g_order'
        const checkout = await dispatch(action_cart_checkout())
        window.location.href = '/cart/checkout?utm_source=ig_g_order'
    },[]);

    return <div className={classes.Container}><Loading /></div>;
}
export default FbCheckoutUrl